import React, { useEffect } from 'react';
import LayoutTwo from '../../Layout/LayoutTwo';
import styles from './PricingPage.module.css'; // Import module-specific styles
import Icon1 from '../../Assets/Pricing/Icon1.png'; // Import asset icons
import Icon2 from '../../Assets/Pricing/Icon2.png';
import Icon3 from '../../Assets/Pricing/Icon3.png';
import Icon4 from '../../Assets/Pricing/Icon4.png';
import expander1 from '../../Assets/Pricing/Expander1.png';
import expander2 from '../../Assets/Pricing/Expander2.png';

const PricingPage = () => {
    // Scroll to the top of the page on component mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <LayoutTwo> {/* Wrapper component for the second layout structure */}
            <div className={styles.pricing}>
                {/* Section 1 */}
                <div className={styles.pricing1}>
                    <div className={styles.pricing1Top}>
                        <h1>Pricing plans that suit you</h1>
                        <p className="pLarge">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                        <div className={styles.pricing1TBottom}>
                            <button>Monthly</button>
                            <button className={styles.pricing1TButton}>Yearly</button>
                        </div>
                    </div>
                    <div className={styles.pricing1Bottom}>
                        {/* Pricing Item 1 */}
                        <div className={styles.pricing1BItem}>
                            <div className={styles.pricing1BITop}>
                                <img src={Icon1} alt="Regular icon" />
                                <div className={styles.pricing1BITRight}>
                                    <h3>Regular</h3>
                                    <p>Starter Plan</p>
                                </div>
                            </div>
                            <div className={styles.pricing1BILine}>.</div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>Limited Projects</h6>
                            </div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>Regular Support Business</h6>
                            </div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>1 month Free Trial</h6>
                            </div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>3GB storage</h6>
                            </div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>Ads Preview</h6>
                            </div>
                            <p className={styles.pricing1BIMText1}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr.</p>
                            <h3 className={styles.pricing1BIMText2}>Free</h3>
                            <p className={styles.pricing1BIMText3}>For Limited Period</p>
                            <button>Get started</button>
                        </div>

                        {/* Pricing Item 2 */}
                        <div className={styles.pricing1BItemMiddle}>
                            <div className={styles.pricing1BITop}>
                                <img src={Icon2} alt="Plantinum icon" />
                                <div className={styles.pricing1BITRight}>
                                    <h3>Plantinum</h3>
                                    <p>Plantinum</p>
                                </div>
                            </div>
                            <div className={styles.pricing1BILine}>.</div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>Limited Projects</h6>
                            </div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>Regular Support Business</h6>
                            </div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>1 month Free Trial</h6>
                            </div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>3GB storage</h6>
                            </div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>Ads Preview</h6>
                            </div>
                            <p className={styles.pricing1BIMText1}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr.</p>
                            <h3 className={styles.pricing1BIMText2}>$342</h3>
                            <p className={styles.pricing1BIMText3}>For Limited Period</p>
                            <button>Get started</button>
                        </div>

                        {/* Pricing Item 3 */}
                        <div className={styles.pricing1BItem}>
                            <div className={styles.pricing1BITop}>
                                <img src={Icon3} alt="Standard icon" />
                                <div className={styles.pricing1BITRight}>
                                    <h3>Standard</h3>
                                    <p>Most popular</p>
                                </div>
                            </div>
                            <div className={styles.pricing1BILine}>.</div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>Limited Projects</h6>
                            </div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>Regular Support Business</h6>
                            </div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>1 month Free Trial</h6>
                            </div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>3GB storage</h6>
                            </div>
                            <div className={styles.pricing1BIMiddle}>
                                <img src={Icon4} alt="Check Mark" />
                                <h6>Ads Preview</h6>
                            </div>
                            <p className={styles.pricing1BIMText1}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr.</p>
                            <h3 className={styles.pricing1BIMText2}>$234</h3>
                            <p className={styles.pricing1BIMText3}>For Limited Period</p>
                            <button>Get started</button>
                        </div>
                    </div>
                </div>

                {/* Section 2 */}
                <div className={styles.pricing2}>
                    <div className={styles.pricing2Container}>
                        <div className={styles.pricing2Left}>
                            <h2>Frequently Asked Questions</h2>
                            <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt.</p>
                        </div>
                        <div className={styles.pricing2Right}>
                            {/* FAQ Item 1 */}
                            <div className={styles.pricing2RItem}>
                                <div className={styles.pricing2RITop}>
                                    <h4>How do I grow my business?</h4>
                                    <img src={expander1} alt="Expander" />
                                </div>
                                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</p>
                            </div>

                            {/* FAQ Item 2 */}
                            <div className={styles.pricing2RItem}>
                                <div className={styles.pricing2RITop}>
                                    <h4>Can I cancel my subscription?</h4>
                                    <img src={expander2} alt="Expander" />
                                </div>
                            </div>

                            {/* FAQ Item 3 */}
                            <div className={styles.pricing2RItem}>
                                <div className={styles.pricing2RITop}>
                                    <h4>How do I contact the support?</h4>
                                    <img src={expander2} alt="Expander" />
                                </div>
                            </div>

                            {/* FAQ Item 4 */}
                            <div className={styles.pricing2RItem}>
                                <div className={styles.pricing2RITop}>
                                    <h4>Is a credit card required?</h4>
                                    <img src={expander2} alt="Expander" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutTwo>
    );
};

export default PricingPage;
